import { get, patch, put, del, post } from 'modules/api';

export const fetchFollowupBasket = distributionId => {
    return get(`distributions/${distributionId}/followup/basket`);
};

export const patchDistribution = (distributionId, payload) =>
    patch(`distributions/${distributionId}`, payload);

export const getDistributionById = (distributionId, payload) =>
    get(`distributions/${distributionId}`, payload);

export const getFarms = distributionId => get(`distributions/${distributionId}/farms`);

export const getSourceFarms = distributionId => get(`distributions/${distributionId}/source-farms`);

export const getProducts = (distributionId, payload) =>
    get(`distributions/${distributionId}/products`, payload);

export const getOrdersNumbers = distributionId =>
    get(`distributions/${distributionId}/orders_numbers`);

export const patchFarmDistribution = (distributionId, farmId, payload) =>
    patch(`distributions/${distributionId}/farms/${farmId}`, payload);

export const getDistributionProgressByFarmId = (distributionId, farmId, payload) =>
    get(`distributions/${distributionId}/progress/${farmId}`, payload);

export const getPrepareByFarmId = (distributionId, farmId) =>
    get(`distributions/${distributionId}/prepare/${farmId}`);

export const getFarmsWithSoldVolume = distributionId =>
    get(`distributions/${distributionId}/followup/farms-with-sold-volume`);

export const getProductTypesByDistributionId = distributionId =>
    get(`distributions/${distributionId}/product_types`);

export const getPickupAndDeliveryOptions = distributionId =>
    get(`distributions/${distributionId}/pickup-and-delivery-options`);

export const getFollowupSummary = distributionId =>
    get(`distributions/${distributionId}/followup/summary`);

export const getFollowupData = distributionId =>
    get(`distributions/${distributionId}/followup/data`);

export const getFollowupFarmsNotParticipating = distributionId =>
    get(`distributions/${distributionId}/followup/farms-not-participating`);

export const getAvailableFarms = distributionId =>
    get(`distributions/${distributionId}/available_farms`);

export const getFarmsForSale = (distributionId, onlyAvailable) =>
    get(`distributions/${distributionId}/list-farms-for-sale?only-available=${onlyAvailable}`);

export const putFarmsSorting = (distributionId, payload) =>
    put(`distributions/${distributionId}/farms-sorting`, payload);

export const postPreviousDistributionProducts = (distributionId, previousDistributionId) =>
    post(
        `distributions/${distributionId}/one_click_sale_preparation?fromDistribution=${previousDistributionId}`
    );

export const patchOpenSale = (distributionId, payload) =>
    patch(`distributions/${distributionId}/open-sale`, payload);

export const saveSaleOpenMessage = (distributionId, payload) =>
    patch(`distributions/${distributionId}/sale-open-message`, payload);

export const getCommunityOrders = distributionId =>
    get(`distribution/${distributionId}/community_orders`);

export const getStocks = distributionId => get(`distributions/${distributionId}/stocks`);

export const patchProduct = (distributionId, payload) =>
    patch(`distributions/${distributionId}/products`, payload);

export const patchSaleOpenDatetime = (distributionId, payload) =>
    patch(`distributions/${distributionId}/sale-open-datetime`, payload);

export const getLastDistributions = ({ distributionId }) =>
    get(`distributions/${distributionId}/lastDistribution`);

export const postBasketItem = (distributionId, payload) =>
    post(`distributions/${distributionId}/basket/items`, payload);

export const getBasket = distributionId => get(`distributions/${distributionId}/basket`);

export const patchBasketItem = (distributionId, offerId, payload) =>
    patch(`distributions/${distributionId}/basket/items/${offerId}`, payload);

export const postBasketConfirm = (distributionId, payload) =>
    post(`distributions/${distributionId}/basket/confirm`, payload);

export const postBasket = distributionId => post(`distributions/${distributionId}/baskets`);

export const postAddProducts = (distributionId, payload) =>
    post(`distributions/${distributionId}/add_products`, payload);

export const postUpdateProducts = (distributionId, payload) =>
    post(`distributions/${distributionId}/update_products`, payload);

export const putHighlightedSortingPriority = (distributionId, payload) =>
    put(`distributions/${distributionId}/products/highlighted/sorting-priority`, payload);

export const putHighlightedProduct = (distributionId, productId) =>
    put(`distributions/${distributionId}/products/${productId}/highlighted`);

export const delHighlightedProduct = (distributionId, productId) =>
    del(`distributions/${distributionId}/products/${productId}/highlighted`);

export const getPushProductsToSale = distributionId =>
    get(`distributions/${distributionId}/push-products-to-sale`);

export const postPushProductsToSale = (distributionId, promotingDistributionId) =>
    post(`distributions/${distributionId}/push-products-to-sale/${promotingDistributionId}`);

export const delPushProductsToSale = (distributionId, promotingDistributionId) =>
    del(`distributions/${distributionId}/push-products-to-sale/${promotingDistributionId}`);

export const postRemoveProducts = (distributionId, farmId) =>
    post(`distributions/${distributionId}/farms/${farmId}/removeProducts`);

export const getFarmById = (distributionId, farmId) =>
    get(`distributions/${distributionId}/farms/${farmId}`);
